import type { Socket } from 'socket.io-client';

import { useAtom, atom } from 'jotai';

const socketAtom = atom<Socket | null>(null);

export const useSocketStore = () => {
  const [socket, setSocket] = useAtom(socketAtom);

  return { setSocket, socket };
};
